import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=1d28b210&scoped=true&"
import script from "./tixian.vue?vue&type=script&lang=js&"
export * from "./tixian.vue?vue&type=script&lang=js&"
import style0 from "./tixian.vue?vue&type=style&index=0&id=1d28b210&prod&lang=less&scoped=true&"
import style1 from "./tixian.vue?vue&type=style&index=1&id=1d28b210&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28b210",
  null
  
)

export default component.exports